<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo md:pt-10 md:pb-4 w-full"
      @clickOnBackground="logState"
    >
      <div class="cardinal mr-auto ml-auto p-5">
        <div
          class="success-container h-full pt-6"
        >
          <div class="text-left flex pl-6 pr-6">
            <div
              class="text-c24 font-c7 w-4/5"
            >
              Ajouter un assureur
            </div>
            <div class="w-1/5 flex justify-end">
              <icon
                :data="icons.fermer"
                height="30"
                width="30"
                class="cursor-pointer"
                original
                @click="fermer"
              />
            </div>
          </div>

          <div class="text-c18 font-c4 mt-6 bg-white p-6 pb-12">
            <div class="text-left text-c12 mt-4">
              Intitulé
            </div>
            <inputo
              class="mt-2"
              placeholder="SUNU"
              @info="retourNom"
            />

            <div class="text-left text-c12 mt-8">
              Adresse
            </div>
            <inputo
              class="mt-2"
              placeholder="Cadjèhoun"
              @info="retourAdresse"
            />

            <div class="text-left text-c12 mt-8">
              Email
            </div>
            <inputo
              class="mt-2"
              type="email"
              @info="retourEmail"
            />

            <div class="text-left text-c12 mt-8">
              Téléphone
            </div>

            <div class="flex items-center">
              <phoneNumber
                class="mt-2 w-4/5"
                @info="retourTelephone"
              />
              <div class="w-1/5 ml-6">
                <div
                  class="w-10 h-10 rounded-50 add flex items-center justify-center cursor-pointer"
                  @click="plus"
                >
                  <div class="text-c18">
                    +
                  </div>
                </div>
              </div>
            </div>

            <div
              v-for="(item, index) in addSession"
              :key="index"
            >
              <add-phone
                :index="index"
                @info="retourPhone"
              />
            </div>


            <div
              v-if="error !== null"
              class="mt-6 text-red text-c14"
            >
              {{ error }}
            </div>
          </div>

          <div class="flex">
            <div class="w-full">
              <buton
                label="Enregistrer"
                radius="0px"
                height="55px"
                :charge="charge"
                @oga="continuer"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupfat'
import buton from '../helper/add/button'
import ic_agence from '../../assets/icons/agenceGray.svg'
import fermer from '../../assets/icons/fermer.svg'
import inputo from '../helper/form/input'
import phoneNumber from '../helper/form/phoneNumber'
import http from "../../plugins/https"
import apiroutes from "../../router/api-routes"
import addPhone from "../cdevs/assureur/addphone"

export default {
  name: 'Success',
  components: { PopupBase, buton, inputo, phoneNumber, addPhone },

  props: {
    activation: {
      type: Boolean,
      default: false
    },
    donne: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      donnes: null,
      wantToMakeOffer: false,
      icons: {
        ic_agence,
        fermer
      },
      telephone: '',
      nom: '',
      adresse: '',
      error: null,
      charge: false,
      email: '',
      addSession: []
    }
  },

  created() {
    this.wantToMakeOffer = this.activation
    this.valueType = this.type
  },

  methods: {
    fermer () {
      this.$emit('oga', false)
    },

    plus () {
      this.addSession.push('')
    },

    continuer (answer) {
      this.charge = true
      this.error = null
      if (this.nom.length > 0 && this.telephone.length > 0) {
        let body = {
          name: this.nom,
          location: this.adresse,
          email: this.email,
          phone: this.telephone,
          meta: {
            secondPhoneNumber: this.addSession
          }
        }
        this.save(body)
      } else {
        this.charge = false
        this.error = 'Veuillez remplir les champs pour continuer'
      }
    },

    save (body) {
      http.post(apiroutes.baseURL + apiroutes.createAssurance, body)
          .then(response => {
            console.log(response)
            this.$emit('oga', true)
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            console.log(error)
            this.error = "Problème de connexion. Veuillez ressayer"
          })
    },

    retourNom (answer) {
      this.nom = answer
    },

    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
    },

    retourAdresse (answer) {
      this.adresse = answer
    },

    retourTelephone (answer) {
      this.telephone = answer
    },

    retourPhone (answer) {
      console.log(answer)
      this.addSession[answer.index] = answer.phoneNumber
    },

    retourEmail (answer) {
      this.email = answer
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/styles/sass/mixin";
    .success {
      z-index: 999;
    }
    .cardinal {
      width: 42%;
    }

    .add{
      background-color: #ECECEC;
    }
    .success-container {
      font-family: $font-default;
      width: 100%;
      background-color: #F5F5F5;
      height: auto;
      margin: auto;
      border-radius: 12px;
    }
    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
        height: 100vh;
      }
      .titre {
        font-size: 18px;
      }
      .bloc1 {
        width: 100%;
      }
      .bloc2 {
        width: 100%;
        font-size: 18px;
      }
      .button {
        width: 100%;
        font-size: 16px;
      }
      .cardinal {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) and (min-width: 770px){
      .cardinal{
        width: 65%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }

    @media screen and (max-width: 769px) and (min-width: 701px){
      .cardinal{
        width: 90%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }
    @media screen and (max-width: 320px){
      .cardinal{
        width: 100%;
      }
      .titre{
        font-size: 14px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 15px;
      }
    }
</style>
